import { DateTime } from 'luxon';
import React from 'react';
import { MetadataFieldNames } from '~/types/common';
import getDateFromISOToLocal from '~/utils/getDateFromISOToLocal';
function comparisonTable(comparisonDetail) {
    const documentMetadata = comparisonDetail.documents
        .map((metadata) => {
        var _a, _b;
        const competitor = (_a = metadata.find(m => m.name === MetadataFieldNames.competitor)) === null || _a === void 0 ? void 0 : _a.value;
        const formTitle = (_b = metadata.find(m => m.name === MetadataFieldNames.formTitle)) === null || _b === void 0 ? void 0 : _b.value;
        return {
            competitor: Array.isArray(competitor) ? competitor : [],
            formTitle: typeof formTitle === 'string' ? formTitle : '',
        };
    }).filter(m => m.competitor.length || m.formTitle);
    return React.createElement("div", { className: 'comparison-table' },
        React.createElement("div", { className: 'comparison-metadata-grid-container metadata-head' },
            React.createElement("div", { className: 'comparison-metadata-grid metadata_header' },
                React.createElement("div", { className: 'col1 header-cell' },
                    React.createElement("span", { className: 'icon-wrapper' },
                        React.createElement("i", { className: "fa-regular fa-calendar-day" })),
                    getDateFromISOToLocal(comparisonDetail.createdAt, DateTime.DATE_FULL)),
                React.createElement("div", { className: 'col2 header-cell' },
                    React.createElement("span", { className: 'icon-wrapper' },
                        React.createElement("i", { className: "fa-regular fa-address-card" })),
                    comparisonDetail.createdBy),
                React.createElement("div", { className: 'col3 header-cell' },
                    React.createElement("span", { className: `status ${comparisonDetail.status === 'Completed'
                            ? 'status-complete'
                            : 'status-inprogress'}` }, comparisonDetail.status || 'In Progress')),
                React.createElement("div", { className: 'clear' }))),
        React.createElement("div", { className: 'comparison-metadata-grid-container metadata-body' }, documentMetadata
            .map((doc) => {
            var _a;
            return (React.createElement("div", { className: "comparison-metadata-grid metadata_content" },
                React.createElement("div", { className: 'col1 body-item' }, (doc.competitor && doc.competitor.length > 0) &&
                    React.createElement(React.Fragment, null,
                        React.createElement("span", { className: 'icon-wrapper' },
                            React.createElement("i", { className: "fa-regular fa-building" })), (_a = doc.competitor) === null || _a === void 0 ? void 0 :
                        _a.join(','))),
                React.createElement("div", { className: 'col2 body-item' },
                    React.createElement("ul", null,
                        React.createElement("li", null,
                            React.createElement("span", { title: doc.formTitle }, doc.formTitle)))),
                React.createElement("div", { className: 'clear' })));
        })));
}
export default comparisonTable;
